import { api } from './api';

/**
 * The platform-level circle confidentiality agreement.
 * Backend: App\Services\CircleAgreement + CircleAgreementController.
 * Spec: docs/plans/CONFIDENTIALITY-LIABILITY.md §4.1 / §5.1.
 */
export interface CircleAgreementStatus {
  accepted: boolean;
  accepted_version: number | null;
  accepted_at: string | null;
  current_version: number;
}

export const getCircleAgreementStatus = async (): Promise<CircleAgreementStatus> => {
  const response = await api.get<CircleAgreementStatus>('/circle-agreement');
  return response.data;
};

export const acceptCircleAgreement = async (): Promise<void> => {
  await api.post('/circle-agreement/accept');
};
